module.exports = __webpack_public_path__ + "img/new-york-rangers.50bdedd9.svg";